import { useLocalSearchParams } from 'expo-router';

import {
  ExpoRouterDemoBackButton,
  ExpoRouterDemoScreen,
  ExpoRouterDemoTitle,
} from '../../../../components';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  const { restaurantSlug } = useLocalSearchParams<{ restaurantSlug: string }>();

  return (
    <ExpoRouterDemoScreen>
      <ExpoRouterDemoTitle>Menu — {restaurantSlug}</ExpoRouterDemoTitle>
      <ExpoRouterDemoBackButton />
    </ExpoRouterDemoScreen>
  );
}
